import React, { useState, useEffect } from "react";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import MUIDataTable from "mui-datatables";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import { Box } from "@material-ui/core";
import { CustomCircularProgress } from "../../components/Progress/CustomCircularProgress";
import {
  useMachineState,
  useMachineDispatch,
} from "../../context/index";
import Popup from "../../components/Controls/Popup";
import Notification from "../../components/SnackBar/Notification";
import MRCForm from "./MRCForm";

import { makeStyles, TableCell, Tooltip } from "@material-ui/core";
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from "../../components/CustomTheme/CustomTheme";
import Confirm from "./Confirm";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
  iconButtonColor: {
    color: "#fff",
    "&:hover": {
      color: "#0000ff",
    },
  },
}));

function MRC() {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [deletedItem, setDeletedItem] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [records, setRecords] = useState(null);
  const [fabricRecord, setFabricRecord] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [upload, setUpload] = useState(false);
  const [MachineList, setMachineList] = useState([]);
  const [fiber, setFiber] = useState([]);

  const user_type = localStorage.getItem("user_type");
  const unit = localStorage.getItem("unit");

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const dispatch = useMachineDispatch();
  const { fabricList, loading, errorMessage } = useMachineState(); //read the values of loading and errorMessage from context

  const AxiosHeader = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  };

  async function fetchStyleWiseMachines() {
    setIsLoading(true);
    try {
      await axios
        .get(`/api/style-wise-machine-list-by-unit/`, AxiosHeader)
        .then((res) => {
          setMachineList(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchStyleWiseMachineDetail(id) {
    setIsLoading(true);
    try {
      await axios
        .get(`/api/style-wise-machine-details/${id}/`, AxiosHeader)
        .then((res) => {
          setRecordForEdit(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const postStyleWiseMachine = async (values, setSubmitting) => {
    console.log("create: ", values);
    try {
      await axios
        .post("/api/style-wise-machines-create/", values, AxiosHeader)
        .then((resp) => {
          setFabricRecord(resp.data);
          // alert(JSON.stringify(values, null, 2));
          setSubmitting(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const updateStyleWiseMachine = async (values, setSubmitting) => {
    console.log("Updated data: ", values);
    try {
      await axios
        .put(
          `/api/style-wise-machines-update/${values.id}/`,
          values,
          AxiosHeader
        )
        .then((resp) => {
          setFabricRecord(resp.data);
          // alert(JSON.stringify(values, null, 2));
          setSubmitting(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const deleteStyleWiseMachine = async (values) => {
    try {
      await axios
        .delete(
          `/api/style-wise-machines-delete/${values.id}/`,
          values,
          AxiosHeader
        )
        .then((resp) => {
          fetchStyleWiseMachines();
          setDeletedItem(null);
          setNotify({
            isOpen: true,
            message: "Deleted Successfully",
            type: "success",
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    fetchStyleWiseMachines();
  }, [fabricRecord, searchOpen]);

  const openInPopup = (item) => {
    fetchStyleWiseMachineDetail(item.id);
    // setRecordForEdit(item);
    setOpenPopup(true);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "style",
      label: "Style",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "unit_name",
      label: "Unit Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "plant_name",
      label: "Plant Unit",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "buyer_name",
      label: "Buyer Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Actions",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let item;
          tableMeta.tableData.forEach(function (fabric) {
            if (fabric.id == tableMeta.rowData[0]) return (item = fabric);
          });
          return (
            <>
              <IconButton
                color="primary"
                onClick={() => {
                  if (user_type === "Admin" || "IE Coordinate") {
                    openInPopup(item);
                  } else {
                    alert("You have no update permission");
                  }
                  // openInPopup(item);
                }}
              >
                <EditIcon fontSize="medium" />
              </IconButton>
              <IconButton
                onClick={() => {
                  if (user_type === "Admin" || user_type === "IE Coordinate") {
                    // deleteStyleWiseMachine(item);
                    setConfirmDelete(true);
                    handleDelete(item);
                  } else {
                    alert("You have no delete permission");
                  }
                }}
              >
                <DeleteIcon color="error" fontSize="medium" />
              </IconButton>
              {/* <Link
                to={{
                  pathname: "/app/machine/details",
                  state: item.id,
                }}
              >
                <IconButton color="primary">
                  <ArrowRightAltIcon fontSize="medium" />
                </IconButton>
              </Link> */}
            </>
          );
        },
      },
    },
  ];

  const handleDelete = (item) => {
    setDeletedItem(item);
    setConfirmDelete(true);
  };

  const confirmDeleteMrc = () => {
    if (deletedItem) {
      deleteStyleWiseMachine(deletedItem);
    }
    setConfirmDelete(!confirmDelete);
  };

  const addOrEdit = (style, resetForm, setSubmitting) => {
    console.log("data: ", style);
    if (!style.id) postStyleWiseMachine(style, setSubmitting);
    else updateStyleWiseMachine(style, setSubmitting);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setNotify({
      isOpen: true,
      message: "Submitted Successfully",
      type: "success",
    });
  };

  const options = {
    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CustomCircularProgress
            size={70}
            thickness={5}
            color="secondary"
            message="Data is loading. Please do not close the tab..."
          />
        ) : (
          "Sorry, there is no matching data to display"
        ),
      },
    },
    filterType: "select",
    selectableRows: false,
    responsive: "standard",
    rowsPerPage: [20],
    rowsPerPageOptions: [20, 50, 100, 200],
    customToolbar: () => {
      return (
        <>
          <Tooltip title={"Add New"}>
            <IconButton
              className={classes.iconButtonColor}
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </>
      );
    },
    print: false,
    download: false,
    searchText: searchValue,
    searchOpen: searchOpen,
  };

  return (
    <React.Fragment>
      <Box position="relative">
        <ThemeProvider theme={CustomTheme}>
          <div>
            <BreadCrumb routeSegments={[{ name: "MRCs" }]} />
            {isLoading ? (
              <MUIDataTable
                title={"MRC List"}
                columns={columns}
                options={options}
                className={classes.pageContent}
              />
            ) : (
              <MUIDataTable
                title={"MRC List"}
                data={MachineList}
                columns={columns}
                options={options}
                className={classes.pageContent}
              />
            )}
            <TableCell className={classes.MuiTableCell} />
            <Popup
              title="MRC Form"
              width="xl"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <MRCForm
                recordForEdit={recordForEdit}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                addOrEdit={addOrEdit}
                AxiosHeader={AxiosHeader}
              />
            </Popup>
            <Confirm
              open={confirmDelete}
              setConfirmDelete={setConfirmDelete}
              onClose={() => setConfirmDelete(false)}
              actionText="delete"
              onConfirm={confirmDeleteMrc}
            />
            <Notification notify={notify} setNotify={setNotify} />
          </div>
        </ThemeProvider>
      </Box>
    </React.Fragment>
  );
}

export default MRC;